const topicItems = [
  { label: '暗夜追踪', count: '128万讨论' },
  { label: '春风十里不如你', count: '96万讨论' },
  { label: '极限挑战', count: '85万讨论' },
  { label: '深海密码', count: '73万讨论' },
  { label: '悬疑烧脑', count: '62万讨论' },
  { label: '甜宠剧场', count: '58万讨论' },
  { label: '国产科幻', count: '51万讨论' },
  { label: '综艺大赏', count: '47万讨论' },
  { label: '古装权谋', count: '43万讨论' },
  { label: '动漫番剧', count: '39万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            大家都在讨论的影视热点
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicItems.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              className="group inline-flex items-center gap-3 px-4 py-2.5 bg-background-50 rounded-full cursor-pointer hover:bg-primary-50 hover:border-primary-300 border border-background-200 transition-all whitespace-nowrap"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                #{topic.label}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}